import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Select, { OnChangeValue, SingleValue } from "react-select";
import { ChoiceOption, OutcomeEvaluation, OutcomeEvaluationAnswer, OutcomesQuestion } from '../../utils/Definitions';
import { OutcomesQuestionNullSwitch } from './OutcomesQuestionNullSwitch';
import VinelandAssessmentTypeGraphic from '../../images/VinelandAssessmentTypeGraphic.png';
import { GlobalContext } from '../../utils/GlobalContext';
import { OutcomesContext } from '../../pages/outcomes/OutcomesContext';
interface Props {
    OutcomeEvaluation: OutcomeEvaluation | null,
    OutcomesQuestion: OutcomesQuestion;
    setOutcomeEvaluationObject: React.Dispatch<React.SetStateAction<OutcomeEvaluation | null>>;
    onChange: any;
    ChildChoiceOnChange: any;
    GetSelectedOption: any;
    NullQuestion: any;
    GetNullValue: any;

}

export const OutcomesQuestionTypeChoice: React.FC<Props> = (props) => {

    const outcomesContext = useContext(OutcomesContext);

    function IsDisabled(): boolean {
        var nullable = props.OutcomeEvaluation?.nullables.find(x => x.questionID == props.OutcomesQuestion?.question.questionId);
        if (nullable) {
            return nullable.value == "True";
        }
        else {
            return false;
        }
    }

    function ShowVinelandGraphic() {
        outcomesContext.setImageModalSource(VinelandAssessmentTypeGraphic);
        outcomesContext.setImageModalActive(true);
    }

    return (
        <div className="grid grid-cols-[1fr_auto] gap-2">
            {/* First Column (grows) */}
            <div key={props.OutcomesQuestion?.question.questionId} className="w-full xl:w-[38rem] h-fit bg-gray-50 border drop-shadow rounded mt-4 p-2">
                <span className="text-xl font-bold">
                    {props.OutcomesQuestion?.question.questionText}
                </span>

                <div className="w-full h-fit m-auto flex">
                    {OutcomesQuestionNullSwitch({
                        onChange: props.onChange,
                        OutcomeEvaluation: props.OutcomeEvaluation,
                        OutcomesQuestion: props.OutcomesQuestion,
                        setOutcomeEvaluationObject: props.setOutcomeEvaluationObject,
                        NullQuestion: props.NullQuestion,
                        GetNullValue: props.GetNullValue,
                    })}

                    <div className="grow">
                        <Select
                            isDisabled={IsDisabled()}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={
                                props.OutcomesQuestion.choices
                                    ? props.OutcomesQuestion.choices
                                    : undefined
                            }
                            onChange={(selectedOption: OnChangeValue<ChoiceOption, false>) =>
                                props.ChildChoiceOnChange(selectedOption, props.OutcomesQuestion)
                            }
                            value={props.GetSelectedOption(props.OutcomesQuestion)}
                        />
                    </div>
                </div>
            </div>

            {/* Second Column (tiny icon, auto width) */}
            <div className={"mt-4 flex items-center " + (props.OutcomesQuestion.question.questionId == 11 ? '' : 'hidden')}>
                <div className="cursor-pointer">
                    <FontAwesomeIcon
                        onClick={ShowVinelandGraphic}
                        className="w-8 h-8 text-lacblue hover:text-lacblue-500"
                        icon={solid("circle-info")}
                    />
                </div>
            </div>

            

        </div>
    );

}

